import { Component } from '@angular/core';
import { WebpageService } from '../../appshared/web/webpage/webpage.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { WebpageModule } from '../../appshared/web/webpage/webpage.module';
import { FooterComponent } from '../../shared/footer/footer.component';
import { HeaderComponent } from '../../shared/header/header.component';

@Component({
  selector: 'app-shipping',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, TranslateModule],
  templateUrl: './shipping.component.html',
  styleUrl: './shipping.component.css',
})
export class ShippingComponent {
  public PageContentHTML: string = '';
  public PageTitle: string = '';
  private datas: any;
  ComID: number = 1;

  dir = localStorage.getItem('locale') == 'ar' ? 'rtl' : 'ltr';

  mainForm: WebpageModule = new WebpageModule();

  constructor(
    private service: WebpageService,
    public translate: TranslateService,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {});
  }

  ngOnInit(): void {
    this.getAllService();
  }

  public getAllService = () => {
    /*    this.isLoading = true;*/
    // this.loader.open();
    this.service.getServiceType('Spare1', this.ComID).subscribe(
      (res) => {
        // this.loader.close();
        this.datas = res as WebpageModule[];
        this.mainForm = this.datas[0];
        this.mainForm.contentAr = this.mainForm.contentAr;
        this.mainForm.contentEn = this.mainForm.contentEn;
        this.mainForm.isVisible = this.mainForm.isVisible;
        this.mainForm.wbWebpageID = this.mainForm.wbWebpageID;
        this.mainForm.titleAr = this.mainForm.titleAr;
        this.mainForm.titleEn = this.mainForm.titleEn;
        this.mainForm.type = this.mainForm.type;
        if (this.translate.currentLang == 'ar') {
          this.PageContentHTML = this.mainForm.contentAr;
          this.PageTitle = this.mainForm.titleAr;
        } else {
          this.PageContentHTML = this.mainForm.contentEn;
          this.PageTitle = this.mainForm.titleEn;
        }
      },
      (err) => {
        console.log(err);
      }
    );

    /*  this.isLoading = false;*/
  };
}
